import React, { useState, useRef, useEffect } from 'react'
import debounce from 'debounce-promise'
import { components } from 'react-select'
import { Field, SelectAsync } from '@arnsbogroup/react-voicearchive'

const InlineLanguageSelect = (props) => {
  const [editing, setEditing] = useState(false)
  const [selectValues, setSelectValues] = useState(props.value)
  const [languageSkillSetOptions, setLanguageSkillSetOptions] = useState([])
  const ref = useRef(null);
  const indicatorColors = {
    '1': 'text-positive'
  }
  const { 
    onChange = () => {},
    label=''
  } = props

  useEffect(() => {
    //Get LanguageSkillSet Options
    fetch(`/rest/v2/language_skill_set`)
      .then((response) => response.json())
      .then((data) => {
        setLanguageSkillSetOptions(data.map((skill) => ({value: skill.uid, label: skill.slug})))
      })
      .catch((err) => {
        toastr.error(err)
      })
  }, [])

  let languages = []
  if (props.value) {
    languages = props.value.map((language) => (
      {
        ...language,
        value: language.uid, 
        label: language.name, 
        skillSet: language.skill_set_id
      }
    )).sort((a,b) => a.skill_set_id - b.skill_set_id)
  }

  const onBlur = () => {
    setEditing(false)
    onChange(selectValues ? selectValues.map((language) => (
      {
        ...language,
        uid: language.value, 
        name: language.label, 
        skill_set_id: getNewSkillSet(language.skillSet)
      }
      )) : [])
  }

  const onFocus = () => {
    setEditing(true)
    setSelectValues(languages)
  }

  const loadOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/language?search[name]=${query}`)
        .then(response => response.json())
        .then((languages) => {
          resolve(languages.map(({ uid, name }) => ({ value: uid, label: name })))
        })
        .catch(reject)
    })
  }, 250)

  const hasNativeLanguage = () => {
    //skillSet 1 = native
    return selectValues.filter((language) => language.skillSet == 1).length
  }
  
  const getNewSkillSet = (skillSet) => {
    if(skillSet) {
      return skillSet
    } else {
      if (hasNativeLanguage()) {
        //value 2 = full-professional 
        return languageSkillSetOptions.find((skill) => skill.value == 2).value
      } else {
        //value 1 = native
        return languageSkillSetOptions.find((skill) => skill.value == 1).value
      }
    }
  }

  const MultiValueLabel = (props) => {
    const [skillSet, setSkillSet] = useState(getNewSkillSet(props.data.skillSet)) 
    const languageId = props.data.value
    const indicatorClasses = indicatorColors[skillSet] ?? 'text-black'

    const handleSkillSetChange = () => {
      const index = languageSkillSetOptions.map(skill => skill.value).indexOf(skillSet);
      let newSkillSet = null
      if ( index == languageSkillSetOptions.length - 1 || index == undefined ) {
        if (hasNativeLanguage()) {
          //value 2 = full-professional
          newSkillSet = languageSkillSetOptions.find((skill) => skill.value == 2).value
        } else {
          //value 1 = native
          newSkillSet = languageSkillSetOptions.find((skill) => skill.value == 1).value
        }
      } else {
        //value 1 = native
        if (hasNativeLanguage() && languageSkillSetOptions[index + 1].value == 1) {
          newSkillSet = languageSkillSetOptions[index + 2].value
        } else {
          newSkillSet = languageSkillSetOptions[index + 1].value
        }
      }
      setSkillSet(newSkillSet)

      //update selected value to have new skill set
      setSelectValues((prevState) => {
        let currentLanguageIndex = prevState.findIndex(language => languageId == language.value)
        prevState[currentLanguageIndex].skillSet = newSkillSet;
        return prevState;
      })
    }
    
    

    return (
      <>
        <label 
          className={`mx-1 text-center rounded my-auto ${indicatorClasses}`} 
          onClick={handleSkillSetChange}
        >
          {skillSet ? languageSkillSetOptions.find((skill) => skill.value == skillSet).label : 'Not Set' }
        </label>
        <components.MultiValueLabel {...props} />
      </>
    );
  };

  return (
    <Field
      label="Languages"
      labelClassName="text-xs"
      onClick={() => ref.current.focus()}
    >
      <span
        ref={ref}
        tabIndex={0}
        onFocus={onFocus}
        className="w-full border-b border-gray-300 hover:border-gray-700 border-dashed cursor-pointer"
      >
        { editing ? (
          <div>
            <SelectAsync
              className="w-full"
              components={{ 
                MultiValueLabel 
              }}
              placeholder="Languages"
              autoFocus
              size='xs'
              onBlur={onBlur}
              value={selectValues}
              onChange={(values) => setSelectValues(values)}
              isMulti
              cacheOptions
              loadOptions={loadOptions}
              openMenuOnFocus
              noOptionsMessage={({ inputValue }) => `No such language: '${inputValue}'`}
              loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
            />
          </div>
        ) : (
          <>{ languages.length ? languages.map((language) => (language.label)).join(', ') : 'Languages' }</>
        ) }
      </span>
    </Field>
  )
}

export default InlineLanguageSelect
